"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Attachment = void 0;
var tslib_1 = require("tslib");
var file_extension_1 = (0, tslib_1.__importDefault)(require("file-extension"));
var react_1 = (0, tslib_1.__importStar)(require("react"));
var strip_extension_1 = (0, tslib_1.__importDefault)(require("strip-extension"));
var flexbox_1 = require("../flexbox");
var icon_button_1 = require("../icon-button");
var input_1 = require("../input");
var padding_1 = require("../padding");
var select_input_1 = require("../select-input");
var stack_1 = require("../stack");
function Attachment(props) {
    var fileName = props.fileName, onRemove = props.onRemove, onUpdate = props.onUpdate, options = props.options, defaultOption = props.defaultOption;
    var fileType = (0, file_extension_1.default)(fileName);
    var _a = (0, react_1.useState)((0, strip_extension_1.default)(fileName)), attmName = _a[0], setAttmName = _a[1];
    var _b = (0, react_1.useState)(options ? options[0].value : ''), selectedOption = _b[0], setSelectedOption = _b[1];
    var handleChange = function (newName, newOption) {
        var name = newName || attmName;
        var option;
        if (options) {
            if (newOption) {
                option = newOption;
            }
            else {
                option = selectedOption;
            }
        }
        setAttmName(name);
        onUpdate(fileName, "".concat(name, ".").concat(fileType), option);
    };
    var handleOptionChange = function (newOption) {
        setSelectedOption(newOption);
        handleChange(undefined, newOption);
    };
    return (react_1.default.createElement(padding_1.Padding, { size: 12 },
        react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center" },
            react_1.default.createElement(flexbox_1.FlexCell, { flex: 4 },
                react_1.default.createElement(stack_1.Stack, { direction: "vertical", gap: 16 },
                    react_1.default.createElement(input_1.Input, { appendText: fileType, type: "text", name: "filename", defaultValue: attmName, disabled: false, onChange: function (val) { return handleChange((0, strip_extension_1.default)(val)); } }))),
            options ? (react_1.default.createElement(flexbox_1.FlexCell, { flex: 2 },
                react_1.default.createElement(padding_1.Padding, { left: 12 },
                    react_1.default.createElement(select_input_1.SelectInput, { onChange: handleOptionChange, options: options, defaultValue: defaultOption })))) : null,
            react_1.default.createElement(flexbox_1.FlexCell, null,
                react_1.default.createElement(padding_1.Padding, { left: 12 },
                    react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center" },
                        react_1.default.createElement(icon_button_1.IconButton, { type: "close", onClick: function (e) {
                                e.preventDefault();
                                onRemove();
                            } })))))));
}
exports.Attachment = Attachment;
//# sourceMappingURL=index.js.map